export const OBSERVE_CPS_LIST = 'OBSERVE_CPS_LIST';
export const OBSERVE_CPS_LIST_SUCCESS = 'OBSERVE_CPS_LIST_SUCCESS';
export const OBSERVE_CPS_LIST_ERROR = 'OBSERVE_CPS_LIST_ERROR';

export const TLPS_LIST = 'TLPS_LIST';
export const TLPS_LIST_SUCCESS = 'TLPS_LIST_SUCCESS';
export const TLPS_LIST_ERROR = 'TLPS_LIST_ERROR';
